import { createPortal } from "react-dom"
import { useNavigate } from "react-router-dom"
import { IconButton } from "../buttons/IconButton"
import { CloseCircle } from "iconsax-react"

type props = {
  width?: number
  children: JSX.Element | JSX.Element[]
  // close?: React.MouseEventHandler<T>
  close: any
}

export const ModalPortal: React.FC<props> = ({ width, children, close }) => {
  const navigate = useNavigate()

  return createPortal(
    <div className="absolute z-40 h-screen w-screen flex justify-center top-0 bottom-0 left-0 right-0 bg-primary/30 backdrop-blur overflow-y-auto">
      <div
        className={`mt-[70%] md:mt-[40%] lg:mt-[10%] h-fit min-w-[460px] w-[90%] md:w-[50%] lg:w-[${
          width ?? 25
        }%]`}
      >
        <div className="relative w-full bg-white text-neutral700 rounded-xl md:shadow p-[42px]">
          <div className="absolute top-0 right-0 m-2">
            <IconButton
              title="Close"
              onClick={close || (() => navigate(-1))}
            >
              <CloseCircle variant="Linear" />
            </IconButton>
          </div>

          {children}
        </div>
      </div>
    </div>,
    document.getElementById("portal")!
  )
}
